//@flow
import * as React from 'react';
import { themr } from 'react-css-themr';
import theme from './HomebaseChip.scss';
import classnames from 'classnames';
import Chip from 'common/components/core/common/Chip';

type Props = {
    className?: string,
    theme: Object,
    homebaseName: string,
    invert?: boolean
};

class HomebaseChip extends React.PureComponent<Props> {
    render() {
        const {
            homebaseName,
            className,
            theme,
            invert,
            backgroundColor,
            noPadding
        } = this.props;
        return (
            <Chip
                leftIcon="homebase"
                className={classnames(className, theme.homebaseChipWrap)}
                showOverflowTooltip
                theme={theme}
                text={homebaseName}
                invert={invert}
                backgroundColor={backgroundColor}
                noPadding={noPadding}
            />
        );
    }
}

const ThemedHomebaseChip = themr('HomebaseChip', theme)(HomebaseChip);

export default ThemedHomebaseChip;
